import { ITokenResponse, ITokenResponseNew } from "../../services/user/user.interface";
import { CreateProfileFormTypeV } from "../../services/user-create/user-create.schema";
import { IUserItemResponse } from "../../services/user-detail/user-detail.interface";
import { IUserStatusResponse } from "../../services/user-status/user-status.interface";

export const actionTypes = {
  SET_EMAIL_SIGN_IN: "SET_EMAIL_SIGN_IN",
  SET_USER_PROFILE: "SET_USER_PROFILE",
  SET_USER_STATUS: "SET_USER_STATUS",
  SET_CREATE_PROFILE: "SET_CREATE_PROFILE",
  SET_TOKEN: "SET_TOKEN",
  SET_CONFIRM_EMAIL_FLOW: "SET_CONFIRM_EMAIL_FLOW",
  SET_TOKEN_NEW: "SET_TOKEN_NEW",
  SET_PHONE_SIGN_IN: "SET_PHONE_SIGN_IN",
  SET_LOCATION: "SET_LOCATION",
  SET_INVITE_REFERRAL_LINK: "SET_INVITE_REFERRAL_LINK",
};

const setEmailSignIn = (email: string) => ({
  type: actionTypes.SET_EMAIL_SIGN_IN,
  payload: email,
});

const setPhoneSignIn = (phone: string) => ({
  type: actionTypes.SET_PHONE_SIGN_IN,
  payload: phone,
});

const setCreateProfile = (user: CreateProfileFormTypeV | null) => ({
  type: actionTypes.SET_CREATE_PROFILE,
  payload: user,
});

const setToken = (token: ITokenResponse | null) => ({
  type: actionTypes.SET_TOKEN,
  payload: token,
});

const setTokenNew = (token: ITokenResponseNew | null) => ({
  type: actionTypes.SET_TOKEN_NEW,
  payload: token,
});

const setUserProfile = (user: IUserItemResponse | null) => ({
  type: actionTypes.SET_USER_PROFILE,
  payload: user,
});

const setUserStatus = (user: IUserStatusResponse | null) => ({
  type: actionTypes.SET_USER_STATUS,
  payload: user,
});

const setUserLocation = (location: string) => ({
  type: actionTypes.SET_LOCATION,
  payload: location,
});

const setInviteReferralLink = (link: string, referralCode: string) => ({
  type: actionTypes.SET_INVITE_REFERRAL_LINK,
  payload: {
    inviteLink: link,
    referralCode: referralCode,
  },
});

export default {
  setEmailSignIn,
  setPhoneSignIn,
  setCreateProfile,
  setToken,
  setUserProfile,
  setUserStatus,
  setTokenNew,
  setUserLocation,
  setInviteReferralLink,
};
